import React, { useEffect, useState } from "react";
import { IPharmaBrand } from "src/types/GlobalInterfaces";
import { toast } from "react-toastify";
import httpRequest from "src/helpers/httpRequest";
import ImageUpload from "src/Components/GlobalComponents/ImageUplaod";
import SimpleInput from "src/Components/SimpleInput";
import PrimaryBtn from "src/Components/GlobalComponents/primaryBtn";

interface IProps {
  onSuccess: () => void;
  isEdit: IPharmaBrand | false;
}

const UpsertPharmaBrand: React.FC<IProps> = ({
  onSuccess = () => {},
  isEdit = false,
}) => {
  const [bannerImage, setBannerImage] = useState<File | null | string>(null);
  const [brandLogo, setBrandLogo] = useState<File | null | string>(null);
  const [brandName, setBrandName] = useState<string>("");
  const [shortDescription, setShortDescription] = useState<string>("");
  const [isLoader, setIsLoader] = useState<boolean>(false);

  const handleSubmit = async () => {
    if (!bannerImage) {
      toast("Banner image is mandatory!", { type: "error" });
    } else if (!brandName) {
      toast("Brand name is mandatory!", { type: "error" });
    } else if (!brandLogo) {
      toast("Brand logo is mandatory!", { type: "error" });
    } else if(!shortDescription) {
      toast("Short description is mandatory!", { type: "error" });
    } else {
      setIsLoader(true);
      const formData = new FormData();
      formData.append("brandName", brandName);
      formData.append("brandLogo", brandLogo);
      formData.append("bannerImage", bannerImage ?? "");
      formData.append("shortDescription", shortDescription);
      const path = isEdit ? `/brand/edit/${isEdit._id}` : "/brand/create";
      const { res, err } = await httpRequest<any>({
        method: isEdit ? "put" : "post",
        path,
        params: formData,
        header: { "Content-Type": "multipart/form-data" },
      });
      if (res) {
        toast(`Brand ${isEdit ? "updated" : "added"} successfully.`, {
          type: "success",
        });
        onSuccess();
      } else {
        toast(err, { type: "error" });
      }
      setIsLoader(false);
    }
  };

  useEffect(() => {
    if (isEdit && typeof isEdit !== "boolean") {
      let {
        brandName = "",
        brandLogo = "",
        bannerImage,
        shortDescription,
      } = isEdit;
      setBrandName(brandName);
      setBrandLogo(brandLogo);
      setBannerImage(bannerImage);
      setShortDescription(shortDescription);
    }
  }, [isEdit]);

  return (
    <div className="table-container">
      <div className="admin-create-role-main">
        <div className="admin-create-role">
          <div className="create-operators-res ">
            <h3 className="font-size-18px text-[#2F2F31] mb-1 font-Poppins-Regular">
              <span className="text-[#FF0000]">* </span> Banner Image
            </h3>
            <ImageUpload
              image={bannerImage}
              onImageChange={setBannerImage}
              extraClasses={"w-full min-h-[150px]"}
              labelId="banner-image-input"
            />
            <h3 className="font-size-18px text-[#2F2F31] mb-1 font-Poppins-Regular">
              <span className="text-[#FF0000]">* </span> Brand Logo
            </h3>
            <ImageUpload
              image={brandLogo}
              onImageChange={setBrandLogo}
              extraClasses={"min-w-[140px]"}
              labelId="brand-logo-input"
            />
            <SimpleInput
              value={brandName}
              onChange={setBrandName}
              isLabel={true}
              labelText="Brand Name"
              isRequired={true}
              maxLength={100}
              id="brand-name-input"
            />
            <SimpleInput
              value={shortDescription}
              onChange={(value) => {
                setShortDescription(value);
              }}
              isLabel={true}
              labelText="Short Description"
              isRequired={true}
              type="textArea"
              rows={5}
              isLimit={300}
              id="short-description-input"
              maxLength={300}
            />
          </div>
        </div>
        <div className="flex justify-end my-6">
          <PrimaryBtn
            loader={isLoader}
            ButtonText="Save"
            btnExtraStyle={{
              backgroundColor: "#00443f",
              borderRadius: "1.5rem",
            }}
            onPress={handleSubmit}
            id="save-brand-btn"
          />
        </div>
      </div>
    </div>
  );
};

export default UpsertPharmaBrand;
